/**
 * DOM関連のメソッド
 */
var dom_service = {
  //フォームデータを送信可能な状態で取得
  get_formdata: function (form) {
    var fd = new FormData();

    $("input", $(form)).each (function () {
      var obj = $(this);

      var name = obj.attr('name');
      var type = obj.attr('type');
      var val = obj.val();

      console.log (name + ' ' + type + ' ' + val);

      if (type == 'file') {
        if (val != '') {
          fd.append(name, obj.prop("files")[0]);
        }
      } else if(type == 'checkbox'){
        if(obj.prop('checked')) {
            fd.append(name, val);
        }
      } else {
        fd.append(name, val);
      }
    });

    $("textarea", $(form)).each (function () {
        var obj = $(this);

        var name = obj.attr('name');
        var type = 'textarea';
        var val = obj.val();

        console.log (name + ' ' + type + ' ' + val);

        fd.append(name, val);
    });

    return fd;
  }
};

exports.dom_service = dom_service;
